
import PreferencesConstants from './../constants/PreferencesConstants';
import assign from 'object-assign';
import AppDispatcher from './../flux/AppDispatcher';
import NodeEvents from 'events';
var EventEmitter = NodeEvents.EventEmitter;

var CHANGE_EVENT = 'preferences.change';
var _displayActivePrerences: (props: any) => any;
var _displayUserSystemPreferences: (props: any) => any;
var _applicationName: string;

var PreferencesStore: IPreferencesStore = assign({}, EventEmitter.prototype, {
    displayActivePreferences(props: any) {
        return _displayActivePrerences(props);
    },

    displayUserSystemPreferences(props: any) {
        return _displayUserSystemPreferences(props);
    },

    hasActivePreferences() {
        if (typeof _displayActivePrerences == 'function' || _displayActivePrerences != null)
            return true;
        else
            return false;
    },

    hasUserSystemPrefrences() {
        if (typeof _displayUserSystemPreferences == 'function' || _displayUserSystemPreferences != null)
            return true;
        else
            return false;
    },

    getApplicationName() {
        return _applicationName;
    },

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback: any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

AppDispatcher.get(PreferencesConstants.DISPATCHER).register(function (payload: any) {
    switch (payload.actionType) {
        case PreferencesConstants.SET_ACTIVE_PREFERENCES:
            _displayActivePrerences = payload.getPrefencesComponentFunc;
            _applicationName= payload.applicationName;
            break;
        case PreferencesConstants.SET_USER_SYSTEM_PREFERENCES:
            _displayUserSystemPreferences = payload.getPrefencesComponentFunc;
            break;
        default:
            _displayActivePrerences = null;
            _displayUserSystemPreferences = null;
            return true;
    }  

    PreferencesStore.emitChange();
    return true;
});


export default PreferencesStore;